var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Old_Icons",
    "data-name": "Outline Old Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,6.31a.36.36,0,0,0-.11-.16l-6-6A.36.36,0,0,0,11.69,0a.41.41,0,0,0-.19,0h-8A.5.5,0,0,0,3,.5V3H.5a.5.5,0,0,0-.5.5v20a.5.5,0,0,0,.5.5h14a.5.5,0,0,0,.5-.5V21h2.5a.5.5,0,0,0,.5-.5V6.5A.41.41,0,0,0,18,6.31Zm-6-4.6L16.29,6H12ZM14,23H1V4H3V20.5a.5.5,0,0,0,.5.5H14ZM4,20V1h7V6.5a.5.5,0,0,0,.5.5H17V20Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.272cbd47f62419472c454bd838bc0da7.svg";
export { ForwardRef as ReactComponent };